import { get12HFormat } from 'modules/core/lib/formatTime'
import users from 'modules/core/store/collections/users'

export const getTimeInUserTimeFormat = (time: string): string => {
  const isTimeFormat12H = !users.current.isTimeFormat24H

  return isTimeFormat12H ? (get12HFormat(time) as string) : time
}
